module.exports = __webpack_public_path__ + "img/24.ec3d0b04.jpg";